/* eslint-disable import/prefer-default-export */
import styled, { css, keyframes } from 'styled-components'
import { rem } from 'polished'

const fadeInAnim = keyframes`
  0% {
    opacity: 0;
    transform: translateY(${rem(60)});
  }
  100% {
    opacity: 1;
    transform: translateY(${rem(0)});
  }
`

const simpleFadeInAnim = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`

export const Wrapper = styled.div`
  opacity: 0;
  will-change: opacity;
  overflow: visible;

  ${({ extraStyle }) =>
    extraStyle &&
    css`
      ${extraStyle}
    `}

  ${({ isVisible, delay, simple }) =>
    isVisible &&
    css`
      animation: ${simple ? simpleFadeInAnim : fadeInAnim} 0.8s ease-out;
      animation-fill-mode: forwards;
      animation-delay: ${delay}s;

      *[data-nested-wrapper] {
        animation-play-state: running;
      }
    `}
`

export const NestedWrapper = styled(Wrapper)`
  animation-play-state: paused;

  ${({ enabled }) =>
    !enabled &&
    css`
      opacity: 1;
      animation: initial;
    `}
`
